import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import 'bootstrap/dist/css/bootstrap.min.css';

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend);

const OrderFulfillmentChart = ({ labels, dataPoints }) => {
  // Calculate dynamic min and max
 const minValue = Math.min(...dataPoints);
const maxValue = Math.max(...dataPoints);

const minY = minValue > 0 ? Math.floor(minValue - 5) : 0;
const maxY = Math.ceil(maxValue + 20);

  // console.log(maxY,"maxY")

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'On-Time Fulfillment %',
        data: dataPoints,
        borderColor: '#002bff',
        backgroundColor: '#002bff',
        tension: 0.4,
        fill: false,
        pointBorderColor: '#002bff',
        pointBackgroundColor: '#fff',
        pointRadius: 4,
        pointBorderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: '#002bff',
          font: { size: 12, family: 'sans-serif' },
        },
      },
    },
    scales: {
      y: {
        min: minY,
        max: maxY,
        ticks: {
          stepSize: 5,
          color: '#333',
          font: { size: 12 },
        },
        grid: { color: '#eaeaea' },
      },
      x: {
        ticks: { color: '#333', font: { size: 12 } },
        grid: { color: '#f0f0f0' },
      },
    },
  };

  return (
    <div className="container my-4">
      <div style={{ height: '300px' }}>
        <Line data={data} options={options} />
      </div>
    </div>
  );
};

export default OrderFulfillmentChart;
